import { render } from "./ProjectSummaryBox.vue?vue&type=template&id=ac482af2"
import script from "./ProjectSummaryBox.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__